import dayjs from 'dayjs';

export default function getCurrentDateAgendaURL() {
  const now = dayjs();
  return `/agenda/${now.year()}/${now.month() + 1}/`;
}
